import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { deviceReady, loadHackSettings, setHackTheme } from '@src/hacks';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  // HACK: устанавливаем тему при загрузке. удаляем в ThemeSwitcherService
  setHackTheme();

  // HACK: для динамической подмены BASE_PATH_MESSENGER в app.module.ts
  loadHackSettings(() => {
    platformBrowserDynamic().bootstrapModule(AppModule);
  });
};

deviceReady(() => {
  bootstrap();
});
